import { render, staticRenderFns } from "./RemoveFromTickListBtn.vue?vue&type=template&id=937d9cb6"
import script from "./RemoveFromTickListBtn.vue?vue&type=script&lang=js"
export * from "./RemoveFromTickListBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports